import { render, staticRenderFns } from "./ModerationDistributions.vue?vue&type=template&id=5b61e933&"
import script from "./ModerationDistributions.vue?vue&type=script&lang=ts&"
export * from "./ModerationDistributions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports